window.addEventListener('load', (event) => {
  const breadcrumbsData = document.querySelector('[data-breadcrumbs]');
  if (!breadcrumbsData) return;
  // prevent storing product pages in history
  if (breadcrumbsData.dataset.hasOwnProperty('type') && breadcrumbsData.dataset.type === 'product') {
    setProductBreadcrumbs();
    return;
  }

  const historyData = window.sessionStorage.getItem('breadcrumbs-history');
  const history = historyData ? JSON.parse(historyData) : [];
  const maxHistoryLength = 3;

  const currentPage = {
    title: breadcrumbsData.dataset.title,
    url: breadcrumbsData.dataset.url,
    type: breadcrumbsData.dataset.type,
  };
  // prevent storing same page as last one
  if (history.length && history[history.length - 1].title === currentPage.title) return;
  history.push(currentPage);
  if (history.length > maxHistoryLength) history.shift();
  window.sessionStorage.setItem('breadcrumbs-history', JSON.stringify(history));
});

function setProductBreadcrumbs() {
  const historyData = window.sessionStorage.getItem('breadcrumbs-history');
  const history = historyData ? JSON.parse(historyData) : [];
  const productBreadcrumbs = document.querySelector('[data-product_breadcrumbs="data"]');
  if (!productBreadcrumbs) return;
  const productCollectionsData = productBreadcrumbs.querySelectorAll('[data-breadcrumbs_data]');
  if (!productCollectionsData.length) return;
  const productCollections = [];
  productCollectionsData.forEach((collectionData) => {
    productCollections.push({
      title: collectionData.dataset.title,
      url: collectionData.dataset.url,
    });
  });
  console.log(productCollections);
  if (!productCollections.length) return;
  productBreadcrumbs.parentElement.removeChild(productBreadcrumbs);
  const productCollectionBreadcrumbs = document.querySelector('[data-product_breadcrumbs="collection"]');
  if (!productCollectionBreadcrumbs) return;
  const lastHistoryItem = history.length - 1;
  if (history.length === 0 || history[lastHistoryItem].type !== 'collection') {
    const productCollection = productCollections.shift();
    productCollectionBreadcrumbs.textContent = productCollection.title;
    productCollectionBreadcrumbs.href = productCollection.url;
    return;
  }
  const selectedCollection = productCollections.find(
    (collection) => collection.title === history[lastHistoryItem].title
  );
  const productCollection = selectedCollection ? selectedCollection : productCollections.shift();
  productCollectionBreadcrumbs.textContent = productCollection.title;
  productCollectionBreadcrumbs.href = productCollection.url;
}
